import { render } from "./ids.vue?vue&type=template&id=9cb2b5be"
import script from "./ids.vue?vue&type=script&lang=js"
export * from "./ids.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__